import React, { useEffect, useState } from "react";
import axiosInstance from "../utils/axiosInstance";
import { CheckCircle, Loader2 } from "lucide-react";

const PaymentSuccess = () => {
  const [loading, setLoading] = useState(true);
  const [sessionData, setSessionData] = useState(null);

  useEffect(() => {
    const getPayment = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const sessionId = urlParams.get("session_id");

      if (!sessionId) {
        setLoading(false);
        return;
      }

      try {
        const { data } = await axiosInstance.get(`/api/payments/session/${sessionId}`);
        setSessionData(data);
      } catch (err) {
        console.error("❌ Failed to fetch Stripe session:", err);
      } finally {
        setLoading(false);
      }
    };

    getPayment();
  }, []);

  if (loading) {
    return (
      <div className="min-h-dvh flex items-center justify-center bg-candy-background">
        <Loader2 size={40} className="animate-spin text-candy-primary" />
      </div>
    );
  }

  return (
    <div className="min-h-dvh bg-candy-background px-4 py-10 sm:py-12">
      <div className="w-full max-w-xl mx-auto bg-white border border-candy-border rounded-2xl shadow-xl p-8 text-center">

        <h1 className="text-3xl sm:text-4xl font-bold text-candy-text font-hobo mb-2">
          🎉 Payment Successful!
        </h1>

        <CheckCircle className="text-green-500 mx-auto mt-2 mb-4" size={60} />

        <p className="text-gray-700 text-base sm:text-lg">
          Thank you! Your payment has been processed successfully.
        </p>

        <p className="text-gray-600 text-sm mt-1">
          A confirmation has been sent to your email.
        </p>

        {/* SESSION DETAILS IF AVAILABLE */}
        {sessionData && (
          <div className="mt-6 bg-green-100 border-l-4 border-green-600 text-green-900 p-4 rounded-lg text-left">
            <p className="font-semibold">💵 Payment Details</p>

            <p className="text-sm mt-1">
              <strong>Amount Paid:</strong>{" "}
              ${(sessionData.amount_total / 100).toFixed(2)}
            </p>

            {sessionData.customer_details?.name && (
              <p className="text-sm mt-1">
                <strong>Name:</strong> {sessionData.customer_details.name}
              </p>
            )}

            {sessionData.customer_details?.email && (
              <p className="text-sm mt-1">
                <strong>Email:</strong> {sessionData.customer_details.email}
              </p>
            )}
          </div>
        )}

        {/* <button
          onClick={() => navigate("/")}
          className="mt-8 inline-flex items-center justify-center bg-candy-primary text-white px-6 py-2.5 rounded-full text-sm sm:text-base font-semibold shadow-md hover:bg-candy-primaryDark transition-all duration-200"
        >
          ← Home
        </button> */}

      </div>
    </div>
  );
};

export default PaymentSuccess;
